import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t } = useTranslation('common');

  return (
    <footer className='footer-main'>
      <div className='container-mobile'>
        <div className='footer-bottom-content'>
          <p className='footer-copyright'>
            <picture>
              <source srcSet='/images/logo.webp' type='image/webp' />
              <img src='/images/logo.png' alt='Presencia App' className='logo-small' width={150} height={21} loading='lazy' />
            </picture>
          </p>
          <div className='footer-bottom-links'>
            <Link to='/privacy' className='footer-bottom-link'>
              {t('footer.privacy')}
            </Link>
            <Link to='/terms' className='footer-bottom-link'>
              {t('footer.terms')}
            </Link>
            <Link to='/refund-policy' className='footer-bottom-link'>
              {t('footer.refunds')}
            </Link>
            <Link to='/faqs' className='footer-bottom-link'>
              {t('footer.faqs')}
            </Link>
          </div>
        </div>
        <div className='footer-contact-row'>
          {t('footer.contactMessage')}{' '}
          <a href='mailto:contact@presencia-app.com' className='contact-link'>
            contact@presencia-app.com
          </a>
        </div>
        <div className='flex justify-center footer-copynote'>
          {t('footer.copyright')}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
